import { Table } from "semantic-ui-react"
import { AccountsReceivableReportItemDto } from "../../../../app/models/accountsReceivable";
import { useTranslation } from "react-i18next";
import { observer } from "mobx-react-lite";
import React from "react";
import { format } from "date-fns";
import { formatCurrency } from "../../../../app/common/util/functions";


interface Props {
  allValues: AccountsReceivableReportItemDto[];
  groupedValues: [string, AccountsReceivableReportItemDto[]][];
  calculateTotals: (data: AccountsReceivableReportItemDto[]) => number;
  calculateTotalBalanceDue: (data: AccountsReceivableReportItemDto[]) => number;
}

export default observer(function AccountsReceivablePrintDetailed({
  calculateTotals,
  calculateTotalBalanceDue,
  groupedValues,
  allValues,
}: Props) {
  const { t } = useTranslation(["common", "reports"]);

  return (
    <>
      {groupedValues.map(([group, items], groupIndex) => (
        <React.Fragment key={groupIndex}>
          <>
            <Table.Body>
              <Table.Row>
                <Table.Cell
                  colSpan={16}
                  textAlign="left"
                  className="terms_bold"
                >
                  {group}
                </Table.Cell>
              </Table.Row>
            </Table.Body>
            <Table.Header>
              <Table.Row>
                <Table.HeaderCell textAlign="left">
                  {t("ticketnum", { ns: "common" })}
                </Table.HeaderCell>
                <Table.HeaderCell>
                  {t("date", { ns: "common" })}
                </Table.HeaderCell>
                <Table.HeaderCell>
                  {t("description", { ns: "common" })}
                </Table.HeaderCell>
                <Table.HeaderCell textAlign="right">
                  {t("labels.ticketTotal", { ns: "inventory" })}
                </Table.HeaderCell>
                <Table.HeaderCell textAlign="right">
                  {t("balanceDue", { ns: "accountsReceivable" })}
                </Table.HeaderCell>
              </Table.Row>
            </Table.Header>
            <Table.Body>
              {items.map((item: AccountsReceivableReportItemDto, itemIdx: number) => (
                <Table.Row key={itemIdx}>
                  <Table.Cell
                    className="hoveredLink"
                    onClick={() => window.open(`/ticket/view/${item.ticketId}`, `_`)}
                    data-label={`${t("ticketnum", { ns: "common" })}:`}
                  >
                    #{item.ticketNumber}
                  </Table.Cell>
                  <Table.Cell
                    data-label={`${t("date", { ns: "common" })}:`}
                  >
                    {item.ticketDate ? format(new Date(item.ticketDate), 'P') : null}
                  </Table.Cell>
                  <Table.Cell
                    data-label={`${t("description", { ns: "common" })}:`}
                  >
                    {item.description}
                  </Table.Cell>
                  <Table.Cell
                    textAlign="right"
                    data-label={`${t("balanceDue", { ns: "accountsReceivable" })}:`}
                  >
                    {formatCurrency(item.balanceDue)}
                  </Table.Cell>
                  <Table.Cell
                    data-label={`${t("labels.ticketTotal", { ns: "inventory" })}:`}
                    textAlign="right"
                  >
                    {formatCurrency(item.total)}
                  </Table.Cell>
                </Table.Row>
              ))}

              <Table.Row className="terms_bold">
                <Table.Cell>{t("total", { ns: "common" })}</Table.Cell>
                <Table.Cell textAlign="right"></Table.Cell>
                <Table.Cell textAlign="right"></Table.Cell>
                <Table.Cell textAlign="right">
                  {formatCurrency(calculateTotalBalanceDue(items))}
                </Table.Cell>
                <Table.Cell
                  textAlign="right"
                  data-label={`${t("total", { ns: "common" })}:`}
                >
                  {formatCurrency(calculateTotals(items))}
                </Table.Cell>
              </Table.Row>
              <Table.Row className="noBackground">
                <Table.Cell colSpan={11}></Table.Cell>
              </Table.Row>
            </Table.Body>
          </>
        </React.Fragment>
      ))}
      <Table.Row className="terms_bold greenRow">
        <Table.Cell>{t("grandTotals", { ns: "reports" })}</Table.Cell>
        <Table.Cell textAlign="right"></Table.Cell>
        <Table.Cell textAlign="right"></Table.Cell>
        <Table.Cell textAlign="right">
          {formatCurrency(calculateTotalBalanceDue(allValues))}
        </Table.Cell>
        <Table.Cell
          textAlign="right"
          data-label={`${t("total", { ns: "common" })}:`}
        >
          {formatCurrency(calculateTotals(allValues))}
        </Table.Cell>
      </Table.Row>
    </>
  );
});


